import firebase from 'firebase/app'

/**
 * Firestore DateSerializer
 *
 *
 */
export const DateSerializer = {
  Serialize(value: Date): string {
    return `${value.getTime()}`
  },

  Deserialize(json: any): Date {
    if (json instanceof firebase.firestore.Timestamp) {
      return new Date(json.seconds * 1000)
    } else if (isNaN(+json)) {
      return new Date(json)
    } else {
      return new Date(+json)
    }
  },
}
